var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.page_key))]),_vm._l((_vm.pageContent),function(definition,index){return _c('SEO_TextBlock',{key:`${_vm.page_key}-content-${index}`,attrs:{"debug":_vm.debug,"language":_vm.language,"definition":definition,"page_key":_vm.page_key}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }